import { connect } from "react-redux";
import ViewSiteInspectionChecklist from "./viewSiteInspectionChecklist";
import { bindActionCreators } from "redux";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { getSiteInfoChecklist } from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
    siteInspectionChecklist: state.siteInspectionReducer.siteInspectionChecklist,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getGateInfo,
      getSiteInfoChecklist,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewSiteInspectionChecklist);
